export const GET_MOBILE_DEVICE_COUNT = "GET_MOBILE_DEVICE_COUNT";
export const GET_MOBILE_DEVICE_COUNT_LOADER = "GET_MOBILE_DEVICE_COUNT_LOADER";
export const GET_AUTHENTICATED_DEVICES = "GET_AUTHENTICATED_DEVICES";
export const GET_DEVICES_LOADER = "GET_DEVICES_LOADER";

export interface IDownloadAppState {
    numberOfAuthenticatedDevices?: number;
    authenticatedDevices?: Registration[];
    isLoading: boolean;
    isLoadingDevices: boolean;
}

export interface Registration {
    appGUID?: string;
    applicationName?: string;
    deviceName?: string;
    deviceType?: string;
    lastAccessed?: string;
}

export interface getMobileDeviceCountAction {
    type: "GET_MOBILE_DEVICE_COUNT";
    numberOfAuthenticatedDevices: number;
}
export interface getAuthenticatedDevicesAction {
    type: "GET_AUTHENTICATED_DEVICES";
    authenticatedDevices: Registration[];
}
export interface getMobileDeviceCountLoaderAction {
    type: "GET_MOBILE_DEVICE_COUNT_LOADER";
    isLoading: boolean;
}
export interface getDevicesLoaderAction {
    type: "GET_DEVICES_LOADER";
    isLoadingDevices: boolean;
}

export type KnownAction = getMobileDeviceCountAction | getAuthenticatedDevicesAction | getMobileDeviceCountLoaderAction | getDevicesLoaderAction;
